var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('advanced-json-editor',{attrs:{"json":this.form.settings.triggers,"height":640},on:{"update:json":function($event){return _vm.$set(this.form.settings, "triggers", $event)},"error":_vm.onError,"updated":_vm.onUpdated}})}
var staticRenderFns = []

export { render, staticRenderFns }